export const projectsTranslations = {
  en: {
    title: 'Projects',
    description: 'Manage and track client projects',
    addProject: 'New Project',
    search: 'Search projects...',
    noProjects: 'No projects found',
    filters: {
      title: 'Filters',
      status: 'Status',
      callNeeded: 'Call Needed',
      upcomingCalls: 'Upcoming Calls',
      overdueTasks: 'Overdue Tasks',
      clearAll: 'Clear all filters'
    },
    form: {
      title: 'Project Details',
      client: {
        label: 'Client',
        placeholder: 'Select a client...'
      },
      projectName: {
        label: 'Project Name',
        placeholder: 'Enter project name'
      },
      description: {
        label: 'Description',
        placeholder: 'Write a detailed description of the project...'
      },
      objectives: {
        label: 'Project Objectives',
        addObjective: 'Add Objective',
        placeholder: 'Enter objective...'
      },
      status: {
        label: 'Status',
        options: {
          planning: 'Planning',
          active: 'Active',
          on_hold: 'On Hold',
          completed: 'Completed',
          cancelled: 'Cancelled'
        }
      },
      nextCall: {
        label: 'Next Call Date',
        placeholder: 'Select date'
      },
      notifications: {
        label: 'Send WhatsApp Notifications',
        description: 'Enable automated WhatsApp notifications for this project'
      },
      buttons: {
        create: 'Create Project',
        update: 'Update Project',
        cancel: 'Cancel'
      }
    },
    tasks: {
      title: 'Tasks',
      addTask: 'Add Task',
      sections: {
        sprint: 'Sprint',
        backlog: 'Backlog',
        completed: 'Completed'
      },
      status: {
        todo: 'To Do',
        in_progress: 'In Progress',
        review: 'Review',
        completed: 'Completed',
        standby: 'Standby'
      },
      priority: {
        urgent: 'Urgent',
        high: 'High',
        medium: 'Medium',
        low: 'Low'
      },
      dueDate: {
        today: 'Today',
        tomorrow: 'Tomorrow',
        yesterday: 'Yesterday',
        overdue: 'Overdue',
        thisWeek: 'This Week'
      },
      call: {
        overdue: 'Call Overdue',
        today: 'Call Today',
        tomorrow: 'Call Tomorrow',
        inDays: 'Call in {days} days',
        on: 'Call on {date}'
      },
      labels: {
        hideCompleted: 'Hide Completed',
        showCompleted: 'Show Completed',
        filterTasks: 'Filter Tasks',
        sortBy: 'Sort by',
        searchTasks: 'Search tasks...',
        viewProject: 'View Project',
        unassignedTasks: 'Unassigned Tasks',
        noTasksFound: 'No tasks found matching your criteria'
      },
      jsonModal: {
        title: 'Export/Import Tasks',
        exportTab: 'Export',
        importTab: 'Import',
        export: {
          title: 'Export Tasks as JSON',
          description: 'Download project tasks in JSON format',
          button: 'Copy JSON',
          copied: 'Copied!',
          noTasks: 'No tasks to export'
        },
        import: {
          title: 'Import Tasks from JSON',
          description: 'Paste JSON to import tasks',
          placeholder: 'Paste JSON here...',
          mode: 'Import Mode',
          modeReplace: 'Replace all tasks',
          modeAppend: 'Add to existing tasks',
          modeReplaceDesc: 'All existing tasks will be deleted',
          modeAppendDesc: 'New tasks will be added to existing ones',
          button: 'Import Tasks',
          importing: 'Importing...',
          preview: 'Preview',
          sections: 'sections',
          tasks: 'tasks',
          invalidJson: 'Invalid JSON format',
          success: 'Successfully imported {count} tasks',
          error: 'Error importing tasks'
        }
      },
      aiGenerator: {
        title: 'AI Task Generator',
        beta: 'Beta',
        steps: {
          input: 'Input',
          config: 'Configuration',
          preview: 'Preview',
          creating: 'Creating'
        },
        input: {
          title: 'Describe your tasks',
          transcriptionLabel: 'Call Transcription',
          transcriptionPlaceholder: 'Paste the call transcription here (optional but recommended)...',
          transcriptionHint: 'The AI will extract tasks from the call context',
          descriptionLabel: 'Task Description',
          descriptionPlaceholder: 'Describe the tasks you need to create...',
          descriptionHint: 'Be specific about what needs to be done',
          examples: 'Example prompts',
          example1: 'Create tasks for a new e-commerce website with design, development, and testing phases',
          example2: 'Generate tasks for a marketing campaign launch including social media, email, and content creation',
          example3: 'Build a task list for app bug fixes and performance improvements'
        },
        config: {
          title: 'Configure generation',
          taskTypes: 'Task Types',
          taskTypesHint: 'Select the types of tasks to generate',
          typeOperative: 'Operative',
          typeAdministrative: 'Administrative',
          typeCommunication: 'Communication',
          typeQA: 'QA/Testing',
          dateRange: 'Date Range',
          dateRangeHint: 'Suggested due dates will be within this range',
          startDate: 'Start Date',
          endDate: 'End Date',
          defaultSection: 'Default Section',
          defaultSectionHint: 'Tasks without a suggested section will be placed here',
          noSection: 'No section'
        },
        preview: {
          title: 'Review generated tasks',
          subtitle: 'Edit tasks before creating them',
          regenerate: 'Regenerate with AI',
          generating: 'Generating tasks...',
          noTasks: 'No tasks generated',
          tryAgain: 'Try with a more detailed description',
          include: 'Include this task',
          taskTitle: 'Title',
          taskDescription: 'Description',
          taskPriority: 'Priority',
          taskAssignee: 'Assignee',
          taskDueDate: 'Due Date',
          taskSection: 'Section',
          taskChecklist: 'Checklist',
          checklistItem: 'Checklist item',
          addChecklistItem: 'Add item',
          removeTask: 'Remove task',
          unassigned: 'Unassigned',
          newSection: 'New section',
          required: 'Required'
        },
        creating: {
          title: 'Creating tasks',
          progress: 'Created {current} of {total} tasks',
          success: 'All tasks created successfully!',
          error: 'Error creating tasks',
          close: 'Close',
          viewTasks: 'View Tasks'
        },
        buttons: {
          back: 'Back',
          next: 'Next',
          generate: 'Generate Tasks',
          create: 'Create Tasks',
          cancel: 'Cancel'
        },
        errors: {
          descriptionRequired: 'Please provide a task description',
          noTasksSelected: 'Please select at least one task',
          generationFailed: 'Failed to generate tasks. Please try again.'
        }
      }
    }
  },
  it: {
    title: 'Progetti',
    description: 'Gestisci e monitora i progetti dei clienti',
    addProject: 'Nuovo Progetto',
    search: 'Cerca progetti...',
    noProjects: 'Nessun progetto trovato',
    filters: {
      title: 'Filtri',
      status: 'Stato',
      callNeeded: 'Chiamata Necessaria',
      upcomingCalls: 'Chiamate in Programma',
      overdueTasks: 'Task scadute',
      clearAll: 'Cancella tutti i filtri'
    },
    form: {
      title: 'Dettagli Progetto',
      client: {
        label: 'Cliente',
        placeholder: 'Seleziona un cliente...'
      },
      projectName: {
        label: 'Nome Progetto',
        placeholder: 'Inserisci nome progetto'
      },
      description: {
        label: 'Descrizione',
        placeholder: 'Scrivi una descrizione dettagliata del progetto...'
      },
      objectives: {
        label: 'Obiettivi del Progetto',
        addObjective: 'Aggiungi Obiettivo',
        placeholder: 'Inserisci obiettivo...'
      },
      status: {
        label: 'Stato',
        options: {
          planning: 'Pianificazione',
          active: 'Attivo',
          on_hold: 'In Sospeso',
          completed: 'Completato',
          cancelled: 'Annullato'
        },
        descriptions: {
          planning: 'Fase iniziale di configurazione e pianificazione del progetto',
          active: 'Il progetto è attualmente in fase di sviluppo',
          on_hold: 'Il progetto è temporaneamente in pausa',
          completed: 'Il progetto è stato completato',
          cancelled: 'Il progetto è stato annullato'
        }
      },
      nextCall: {
        label: 'Prossima Chiamata',
        placeholder: 'Seleziona data'
      },
      notifications: {
        label: 'Invia Notifiche WhatsApp',
        description: 'Abilita notifiche WhatsApp automatiche per questo progetto'
      },
      buttons: {
        create: 'Crea Progetto',
        update: 'Aggiorna Progetto',
        cancel: 'Annulla'
      }
    },
    tasks: {
      title: 'Attività',
      addTask: 'Aggiungi Attività',
      search: 'Cerca attività...',
      toolbar: {
        filter: 'Filtri',
        sort: 'Ordina',
        view: 'Vista',
        listView: 'Lista',
        boardView: 'Board',
        userFilter: 'Utenti',
        eyeButton: 'Visibilità'
      },
      filters: {
        title: 'Filtri Attività',
        status: 'Stato',
        priority: 'Priorità', 
        assignee: 'Assegnato a',
        dueDate: 'Scadenza',
        clearAll: 'Cancella Filtri'
      },
      sorting: {
        title: 'Ordina Per',
        name: 'Nome',
        dueDate: 'Scadenza',
        priority: 'Priorità',
        status: 'Stato',
        created: 'Data Creazione',
        assignee: 'Assegnato'
      },
      sections: {
        sprint: 'Sprint',
        backlog: 'Backlog',
        completed: 'Completate'
      },
      status: {
        todo: 'Da Fare',
        in_progress: 'In Corso',
        review: 'In Revisione',
        completed: 'Completata',
        standby: 'In attesa'
      },
      priority: {
        urgent: 'Urgente',
        high: 'Alta',
        medium: 'Media',
        low: 'Bassa'
      },
      stats: {
        tasks: 'attività',
        completed: 'completate',
        done: 'fatto'
      },
      empty: {
        noTasks: 'Nessuna attività trovata',
        createFirst: 'Crea la tua prima attività',
        dropHere: 'Trascina le attività qui o aggiungi una nuova qui sotto'
      },
      nextCall: 'Prossima chiamata',
      due: 'Scadenza',
      assigned: 'Assegnato',
      dueDate: {
        today: 'Oggi',
        tomorrow: 'Domani', 
        yesterday: 'Ieri',
        overdue: 'In Ritardo',
        thisWeek: 'Questa Settimana'
      },
      call: {
        overdue: 'Chiamata in Ritardo',
        today: 'Chiama Oggi',
        tomorrow: 'Chiama Domani',
        inDays: 'Chiama tra {days} giorni',
        on: 'Prossima chiamata il {date}'
      },
      labels: {
        hideCompleted: 'Nascondi Completate',
        showCompleted: 'Mostra Completate',
        filterTasks: 'Filtra Attività',
        sortBy: 'Ordina per',
        searchTasks: 'Cerca attività...',
        viewProject: 'Visualizza Progetto',
        unassignedTasks: 'Attività Non Assegnate',
        noTasksFound: 'Nessuna attività trovata corrispondente ai criteri'
      },
      jsonModal: {
        title: 'Esporta/Importa Task',
        exportTab: 'Esporta',
        importTab: 'Importa',
        export: {
          title: 'Esporta Task come JSON',
          description: 'Scarica le task del progetto in formato JSON',
          button: 'Copia JSON',
          copied: 'Copiato!',
          noTasks: 'Nessuna task da esportare'
        },
        import: {
          title: 'Importa Task da JSON',
          description: 'Incolla il JSON per importare le task',
          placeholder: 'Incolla il JSON qui...',
          mode: 'Modalità Importazione',
          modeReplace: 'Sostituisci tutte le task',
          modeAppend: 'Aggiungi alle task esistenti',
          modeReplaceDesc: 'Tutte le task esistenti verranno eliminate',
          modeAppendDesc: 'Le nuove task verranno aggiunte a quelle esistenti',
          button: 'Importa Task',
          importing: 'Importazione...',
          preview: 'Anteprima',
          sections: 'sezioni',
          tasks: 'task',
          invalidJson: 'Formato JSON non valido',
          success: 'Importate con successo {count} task',
          error: 'Errore durante l\'importazione delle task'
        }
      },
      aiGenerator: {
        title: 'Generatore Task AI',
        beta: 'Beta',
        steps: {
          input: 'Input',
          config: 'Configurazione',
          preview: 'Anteprima',
          creating: 'Creazione'
        },
        input: {
          title: 'Descrivi le tue task',
          transcriptionLabel: 'Trascrizione Chiamata',
          transcriptionPlaceholder: 'Incolla la trascrizione della chiamata qui (opzionale ma consigliato)...',
          transcriptionHint: 'L\'AI estrarrà le task dal contesto della chiamata',
          descriptionLabel: 'Descrizione Task',
          descriptionPlaceholder: 'Descrivi le task che vuoi creare...',
          descriptionHint: 'Sii specifico su cosa deve essere fatto',
          examples: 'Esempi di prompt',
          example1: 'Crea task per un nuovo sito e-commerce con fasi di design, sviluppo e testing',
          example2: 'Genera task per il lancio di una campagna marketing includendo social media, email e creazione contenuti',
          example3: 'Costruisci una lista di task per la correzione di bug e il miglioramento delle performance dell\'app'
        },
        config: {
          title: 'Configura la generazione',
          taskTypes: 'Tipi di Task',
          taskTypesHint: 'Seleziona i tipi di task da generare',
          typeOperative: 'Operative',
          typeAdministrative: 'Amministrative',
          typeCommunication: 'Comunicazione',
          typeQA: 'QA/Testing',
          dateRange: 'Intervallo Date',
          dateRangeHint: 'Le scadenze suggerite saranno all\'interno di questo intervallo',
          startDate: 'Data Inizio',
          endDate: 'Data Fine',
          defaultSection: 'Sezione Predefinita',
          defaultSectionHint: 'Le task senza sezione suggerita verranno inserite qui',
          noSection: 'Nessuna sezione'
        },
        preview: {
          title: 'Rivedi le task generate',
          subtitle: 'Modifica le task prima di crearle',
          regenerate: 'Rigenera con AI',
          generating: 'Generazione task...',
          noTasks: 'Nessuna task generata',
          tryAgain: 'Prova con una descrizione più dettagliata',
          include: 'Includi questa task',
          taskTitle: 'Titolo',
          taskDescription: 'Descrizione',
          taskPriority: 'Priorità',
          taskAssignee: 'Assegnatario',
          taskDueDate: 'Scadenza',
          taskSection: 'Sezione',
          taskChecklist: 'Checklist',
          checklistItem: 'Elemento checklist',
          addChecklistItem: 'Aggiungi elemento',
          removeTask: 'Rimuovi task',
          unassigned: 'Non assegnato',
          newSection: 'Nuova sezione',
          required: 'Obbligatorio'
        },
        creating: {
          title: 'Creazione task',
          progress: 'Create {current} di {total} task',
          success: 'Tutte le task sono state create con successo!',
          error: 'Errore durante la creazione delle task',
          close: 'Chiudi',
          viewTasks: 'Visualizza Task'
        },
        buttons: {
          back: 'Indietro',
          next: 'Avanti',
          generate: 'Genera Task',
          create: 'Crea Task',
          cancel: 'Annulla'
        },
        errors: {
          descriptionRequired: 'Inserisci una descrizione delle task',
          noTasksSelected: 'Seleziona almeno una task',
          generationFailed: 'Impossibile generare le task. Riprova.'
        }
      }
    }
  }
};